import { cn } from "@/lib/utils";

type ConfidenceTier = "none" | "low" | "medium" | "high" | "mastered";

interface MasteryBadgeProps {
  confidenceTier: ConfidenceTier;
  masteryScore?: number;
  size?: "sm" | "md";
  className?: string;
}

const TIER_COLORS: Record<ConfidenceTier, { ring: string; fill?: string }> = {
  none: { ring: "transparent" },
  low: { ring: "hsl(0, 70%, 55%)" },
  medium: { ring: "hsl(38, 92%, 50%)" },
  high: { ring: "hsl(142, 71%, 45%)" },
  mastered: { ring: "hsl(65, 65%, 75%)", fill: "hsl(65, 65%, 75%)" },
};

export default function MasteryBadge({
  confidenceTier,
  masteryScore,
  size = "sm",
  className,
}: MasteryBadgeProps) {
  if (confidenceTier === "none") return null;

  const { ring } = TIER_COLORS[confidenceTier];
  const dim = size === "sm" ? 14 : 18;
  const stroke = size === "sm" ? 2 : 2.5;

  return (
    <div
      className={cn("flex-shrink-0", className)}
      title={
        masteryScore != null
          ? `${confidenceTier} (${Math.round(masteryScore * 100)}%)`
          : confidenceTier
      }
    >
      <svg width={dim} height={dim} viewBox={`0 0 ${dim} ${dim}`}>
        <circle
          cx={dim / 2}
          cy={dim / 2}
          r={(dim - stroke) / 2}
          fill="none"
          stroke={ring}
          strokeWidth={stroke}
        />
      </svg>
    </div>
  );
}
